interface ApmErrorEvent {
    culprit?: string
    exception?: {
        message?: string
    }
}

interface ApmPayload {
    errors?: ApmErrorEvent[]
}

/**
 * Chrome on iOS and the Google app inject inline scripts (`__gCrWeb` autofill)
 * that since 2026-07-07 overflow the call stack, flooding RUM with
 * "Maximum call stack size exceeded" / "(inline script)" noise across all
 * brands. Not our bug: Safari, on the same engine, never reports it.
 *
 * Scoped to CriOS/GSA user agents because WebKit strips stack traces from
 * overflows, so a genuine overflow in our own bundle would carry the same
 * "(inline script)" culprit — Safari must keep reporting those.
 */
export const dropInjectedScriptOverflowErrors = <T extends ApmPayload>(payload: T, userAgent: string): T => {
    if (!/CriOS|GSA/.test(userAgent)) return payload

    payload.errors = payload.errors?.filter(error =>
        !(error.culprit === '(inline script)' && error.exception?.message?.includes('Maximum call stack size exceeded'))
    )

    return payload
}
